var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgObEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ED1B2E",
    clipPath: "url(#OBEye_svg__clip0_3915_8457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM8.5 10a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.797 5.952c-3.636-3.936-9.958-3.936-13.594 0L.396 8.989a1.487 1.487 0 000 2.022l2.807 3.037c3.636 3.936 9.958 3.936 13.594 0l2.807-3.037a1.487 1.487 0 000-2.022l-2.807-3.037zM4.672 7.309c2.844-3.079 7.812-3.079 10.656 0L17.815 10l-2.487 2.691c-2.844 3.079-7.812 3.079-10.656 0L2.185 10l2.487-2.691z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "OBEye_svg__clip0_3915_8457"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgObEye;